import React from 'react';
import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const AlertInfo = () => {
  return (
    <Alert severity="info">
      <Typography variant="h5">IF CHANGE SERIAL NUMBER FAILED</Typography>
      <Typography variant="h6">
        If the validation of the new serial number succeed but didn&#39;t add,
        do the following:
      </Typography>
      <Typography variant="subtitle2">
        1. Manually add the new serial number to the item.
      </Typography>
      <Typography variant="subtitle2">
        2. Manually void the old serial number in the transaction.
      </Typography>

      <Typography variant="h6" style={{ marginTop: '10px' }}>
        If the item is not available, search another serial number that is
        available
      </Typography>
    </Alert>
  );
};

export const FailedChangeSerialAlertInfo = React.memo(AlertInfo);
